/**
 * Swipe decisions are stored in localStorage: the API exposes no likes/passes
 * endpoints, so a deck reset is per-device rather than per-account.
 */
const EMPTY = { liked: [], passed: [] };

const storageKey = (userId) => `date9.swipes.${userId || 'anon'}`;

export function loadSwipes(userId) {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw);
    return {
      liked: Array.isArray(parsed.liked) ? parsed.liked : [],
      passed: Array.isArray(parsed.passed) ? parsed.passed : [],
    };
  } catch {
    return EMPTY;
  }
}

export function saveSwipes(userId, swipes) {
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(swipes));
  } catch {
    /* private browsing or quota exceeded — decisions stay in memory only */
  }
}

export function recordSwipe(swipes, id, decision) {
  const liked = swipes.liked.filter((x) => x !== id);
  const passed = swipes.passed.filter((x) => x !== id);
  if (decision === 'like') liked.push(id);
  else passed.push(id);
  return { liked, passed };
}
